var t=function(){this.__data__=[],this.size=0};export{t as _};
